import React from "react";
import SearchNav from "../../components/billing/SearchNav";
import ResultTable from '../../components/billing/ResultTable';



export default function Search(props) {
    return (
        <React.Fragment>
            <SearchNav history={props.history} location={props.location}/>
            <ResultTable history={props.history} location={props.location} />
        </React.Fragment>
    );
}
